import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import Loader from '../components/Loader';

class PostcodeCheckerCourierSG extends Component {

    constructor(props) {
        super(props);
        const { location } = props;
        let postcode = '';
        let city = '';
        let price;
        let loading = false;
        let announcement = '';

        this.state = {
            postcode,
            loading,
            city,
            price,
            invalidPostcode: false,
            announcement
        };
    }

    componentWillMount(){
    }

    componentDidMount() {
        // this.handlePostcode()
    }

    handlePostcode = () => {

        const { params: { vendor, id } } = this.props;
        let { postcode } = this.state;

        if (!postcode) {
          return
        }
        this.setState({ loading: true });

        return api('/api/lookup/courier/postcodeSG', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id,
                vendor,
                postcode,
                id
            })
        }).then(result => {

            this.setState({ loading: false });

            if(result){
                this.setState({
                result: result.result,
                city: result.city,
                price: result.price,
                invalidPostcode: false,
                announcement: result.announcement
                });
            } else {
                this.setState({ invalidPostcode: true,
                    result: undefined
                 });
            }
        })
    }

    handlePostcodeChange = (event) => {
        this.setState({ postcode: event.target.value });
    }

    handleEnterPress = (e) => {
        if(e.key === "Enter"){
            this.handlePostcode();
        }
    }

    render() {
        const { error } = this.props
        const { postcode, loading, result, city, price, invalidPostcode, announcement } = this.state;

        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div>
                            {
                                error &&
                                <Alert bsStyle="danger">
                                    <div>{error}</div>
                                </Alert>
                            }
                            <label className="sub-header">Delivery Information (By Courier)</label>
                                <div className="row">
                                    {/* <div>Ship to: <b>Singapore</b></div> */}
                                    {/* <div>Est. Delivery Date: <b>{result}</b></div> */}
                                    {/* { */}
                                    {/*     price > 0 && */}
                                    {/*     <div>Est. Shipping Fee For 1 Unit: From <b>RM{price.toFixed(2)}</b></div> */}
                                    {/* } */}
                                  <div className="col-xs-9">
                                    <div className="form-group">
                                      <input className="form-control" placeholder="Enter postcode" type="text" onChange={this.handlePostcodeChange} onKeyPress={this.handleEnterPress} />
                                    </div>
                                  </div>
                                  <div className="col-xs-3">
                                    <Button className="btn-postcode-checker" onClick={this.handlePostcode} block disabled={loading} >{loading ? 'Loading...' : 'Apply'}</Button>
                                  </div>
                                </div>
                                {
                                  loading &&
                                    <Loader/>
                                }
                                {
                                  !result && !invalidPostcode &&
                                    <div>
                                      <p>Enter the postcode of shipping address to get delivery ETA</p>
                                    </div>
                                }
                                {
                                  !loading && result &&
                                    <div>
                                      <div>General Location: <b>{city}</b></div>
                                      <div>Est. Delivery Date: <b>{result}</b></div>
                                      {
                                        price > 0 &&
                                          <div>Est. Shipping Fee For 1 Unit: From <b>${price.toFixed(2)}</b></div>
                                      }
                                      {
                                        announcement &&
                                          <div>{announcement}</div>
                                      }
                                    </div>
                                }
                                {
                                  invalidPostcode &&
                                    <div>
                                      <p>You entered an invalid postcode. Please try again.</p>
                                    </div>
                                }
                            <hr/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {

    };
})(PostcodeCheckerCourierSG);
